import config from '@config';
import request from '@service/request';
import { getAuthOptions } from '@service/utils.js';

const path = `${config.apiURL}/users`;

export const searchUser = (token, $search) =>
  request.get(path, {
    params: {
      $search,
      $limit: 5,
    },
    ...getAuthOptions(token),
  });

export const searchUserByUsername = (token, username) =>
  request.get(path, {
    params: {
      username,
      $limit: 1,
    },
    ...getAuthOptions(token),
  });

export const udpateUserStats = (token, id, changes) =>
  request.patch(`${path}/${id}`, changes, getAuthOptions(token));

export const getUser = (token, userId) => request.get(`${path}/${userId}`);
